module.exports = __webpack_public_path__ + "img/aboutus.ff4f79ce.png";